import { a194 } from "Components/Api/RootApiPath";

export const getAllDiamondAttribute = async ({ queryKey }) => {
    console.log("working")
  const [,clientCode] = queryKey
  try {
    const data = await fetch(a194, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        clientCode
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(`${response.statusText || "Failed to add stock"}`);
    }
    return data?.json();
  } catch (e) {
    console.log(e);
    throw new Error(`${"Failed to add stock, try again later"}`);
  }
};